import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ModuleNavBar } from "../../components";
import { useSelector, useDispatch } from "react-redux";
import { getSessionStatus, commonAction, getDepartments, getCurrentUser, isAdmin, isArchitect } from "@neumetric/blueprint-lib/store";
import { AppErrorBoundary } from "@neumetric/blueprint-lib/components";

export const ControllerHomeScreen = (props) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const initialized = React.useRef(false);
  const dispatch = useDispatch();
  const sessionStatus = useSelector(getSessionStatus);
  const departments = useSelector(getDepartments);
  const currentUser = useSelector(getCurrentUser);
  const hasAccess = isAdmin(currentUser) || isArchitect(currentUser);

  const isListLoaded = Array.isArray(departments);
  React.useEffect(() => {
    if (sessionStatus === "LOGGED_IN" && currentUser && !initialized.current) {
      initialized.current = true;
      if (!hasAccess) {
        navigate("/module-restricted");
        return;
      }
      dispatch(commonAction.fetchDepartments());
    }
  }, [sessionStatus, hasAccess]);

  return (
    <AppErrorBoundary>
      {isListLoaded && hasAccess && (
        <React.Fragment>
          <ModuleNavBar pathname={pathname} />
          {props.children}
        </React.Fragment>
      )}
    </AppErrorBoundary>
  );
};

export const useHeaderNavItems = () => {
  const { pathname } = useLocation();
  const getNavItems = () => {
    let links = [];
    let defaultLink = "";
    if (pathname.startsWith("/M")) {
      defaultLink = pathname.split("/")[2] === "R" ? "risk" : "list";
      links = [
        { label: "List", link: "/M/L", id: "list" },
        { label: "Risk", link: "/M/R", id: "risk" },
      ];
    }
    else if (pathname.startsWith("/A")) {
      defaultLink = pathname.split("/")[2] === "M" ? "blueprint" : "report";
      links = [
        { label: "Blueprint", link: "/A/M", id: "blueprint" },
        { label: "Report", link: "/A/R", id: "report" },
      ];
    }
    return { links, defaultLink };
  };
  return {
    navigation: getNavItems(),
  };
};
